import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";

const initialState = {
  uimodules: [],
  loading: false,
};

export const getUimodules = createAsyncThunk(
  "uimodules/getuimodules",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `ui-modules?page=${data.page}&limit=${data.limit}`,
    });
    console.log("uimodule Get", res);
    return res;
  }
);

export const createUimodule = createAsyncThunk(
  "uimodule/createuimodule",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: "ui-modules",
      data: data,
    });
    return res;
  }
);

export const deleteUimodule = createAsyncThunk(
  "uimodule/deleteuimodule",
  async (moduleID) => {
    const res = await apiRequest({
      method: "delete",
      url: `ui-modules/${moduleID}`,
    });
    return res;
  }
);

export const updateUimodule = createAsyncThunk(
  "uimodule/updateuimodule",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: "ui-modules",
      data: data,
    });
    return res;
  }
);

const uimoduleSlice = createSlice({
  name: "uimodule",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUimodules.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUimodules.fulfilled, (state, action) => {
      state.loading = false;
      state.uimodules = action.payload;
    });
    // -----------------------------------adduimodule--------------------------
    builder.addCase(createUimodule.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createUimodule.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createUimodule.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // ------------------------------------update--------------------------------
    builder.addCase(updateUimodule.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateUimodule.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateUimodule.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // ---------------------------delete--------------------------------
    builder.addCase(deleteUimodule.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteUimodule.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

// export const { apiCallData } = permissionSlice.actions;

export default uimoduleSlice.reducer;
